// removed by extract-text-webpack-plugin
module.exports = {"inputContainer":"RwI5B7d9Wx6fCIXwwDXW6","inputSearchIcon":"_2fmOeWiZsrf0dCw50r_YSf","searchInput":"_2PNiTgBAayWLk94vcw3WAi","searchCloseIcon":"_3MGmRKdLySUUcuKWkX_PvI"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Search/Search.pcss
// module id = 1288
// module chunks = 0